import React, { useEffect, useState } from "react";
import { DrawerContent, HostContainer } from "./drawer.styles";
import cx from "classnames";
import { DrawerProps } from "./drawer.props";
import { DrawerExpandButton } from "../drawer-expand-button/drawer-expand-button.component";
import { DrawerCollapseButton } from "../drawer-collapse-button/drawer-collapse-button.component";

export const Drawer = (props: DrawerProps) => {
  const [wasOpen, setWasOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (props.open) {
      return setWasOpen(true);
    }
    setIsExpanded(false);
  }, [props.open]);

  const expand = () => {
    if (props.onExpandChange) {
      props.onExpandChange(true);
    }
    setIsExpanded(true);
  };

  const collapse = () => {
    if (props.onExpandChange) {
      props.onExpandChange(false);
    }
    setIsExpanded(false);
  };

  const getClassName = () => ({
    open: props.open,
    expanded: isExpanded,
    closed: !props.open && wasOpen,
  });

  return (
    <HostContainer className={cx(getClassName())}>
      <DrawerContent>
        <DrawerExpandButton showIf={Boolean(props.expandable) && !isExpanded} onClick={expand} />
        <DrawerCollapseButton showIf={Boolean(props.expandable) && isExpanded} onClick={collapse} />
        {props.children}
      </DrawerContent>
    </HostContainer>
  );
};
